import { useState } from 'react';

import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';

import { Block } from 'components/page';
import {
    DreConfigSubgruposList,
    DreConfigConfiguracoesList,
    DreConfigSubgruposModal,
    DreConfigConfiguracoesModal,
} from 'pages/financeiro/dre/configuracao/components';
import { DreConfigTitle } from 'pages/financeiro/dre/configuracao/components/DreConfigTitle';
import { DreConfigConfiguracoesProvider, useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts';

export function DreConfigList() {
    const [openConfiguracoesModal, setOpenConfiguracoesModal] = useState(false);
    const [openSubgruposModal, setOpenSubgruposModal] = useState(false);
    const { activeGrupo } = useDreConfigContext();
    const isImpostos = activeGrupo?.dreMercadologicaTipoGrupoExibicaoEnum === 'IMPOSTOS';

    let title = isImpostos ? 'Configurações' : 'Subgrupos';

    if (activeGrupo) {
        title += ` de ${activeGrupo.dsDreMercadologicaTipoGrupoExibicao}`;
    }

    return (
        <Block
            sx={{
                flex: 10,
                margin: 0,
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <DreConfigTitle title={title}>
                <DreConfigSubgruposModal open={openSubgruposModal} setOpen={setOpenSubgruposModal} />

                <Button
                    size="small"
                    variant="text"
                    startIcon={<Add />}
                    sx={{ color: 'common.white' }}
                    onClick={() => {
                        if (isImpostos) {
                            setOpenConfiguracoesModal(true);
                        } else {
                            setOpenSubgruposModal(true);
                        }
                    }}
                >
                    {isImpostos ? 'Adicionar configuração' : 'Adicionar subgrupo'}
                </Button>
            </DreConfigTitle>

            {!isImpostos && <DreConfigSubgruposList />}

            {isImpostos && (
                <DreConfigConfiguracoesProvider>
                    <DreConfigConfiguracoesModal open={openConfiguracoesModal} setOpen={setOpenConfiguracoesModal} />

                    <DreConfigConfiguracoesList title={false} />
                </DreConfigConfiguracoesProvider>
            )}
        </Block>
    );
}
